import { z } from "zod";
import { discountConfiguration, redoDiscountSchema } from "./discount-schemas";

export const createDiscount = {
  input: z.object({ discountConfiguration: discountConfiguration }),
  output: redoDiscountSchema,
};
